// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#dezrann[data-v-1c515b86]{overflow:scroll;border:1px solid #bbb;border-radius:3px;box-shadow:1px 1px 3px #bbb}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
